import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../../models/https';
import useHttps from '../../useHttps';
import { useAppDisPatch } from '../../../redux/store';
import { bookmarkedLocumJobsActions } from '../../../redux/slices/bookmarkedLocumJobsSlice';

const useBookmarkJob = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();

  const onBookmarkJobError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ?? 'Something while bookmarking job'
    );
  };

  const bookmarkJob = (jobId: string) => {
    const url: HttpConfig = {
      url: `jobs-service/bookmarks`,
      method: 'post',
      data: { jobId },
    };

    request(
      url,
      (response: SuccessHttpResponse<any>) => {
        toast.success(response.message);
        // Dispatch an action to add the bookmark mapping entry.
        dispatch(
          bookmarkedLocumJobsActions.addBookmarkMapping({
            jobId,
            bookmarkId: response.data.id,
          })
        );
      },
      setLoading,
      onBookmarkJobError
    );
  };

  return { bookmarkJob, loading };
};

export default useBookmarkJob;
